// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"403f4ab4","593":"5889ba4e","787":"d1d4a2c2","924":"6f598c52"}[chunkId] + ".chunk.js";
};